import {
  getFormValue,
  setQuestionVisibility,
  clearFieldValue,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum } from 'app/shared/enums';

const cession = {
  onCessionRequiredChange(initialRun: boolean) {
    const isCessionRequired = getFormValue(
      FieldsEnum.CessionRequired,
      FormsEnum.CheckoutForm
    );
    if (!initialRun) {
      clearFieldValue(FieldsEnum.BankZipCode, FormsEnum.CheckoutForm);
      clearFieldValue(FieldsEnum.BankId, FormsEnum.CheckoutForm);
    }
    setQuestionVisibility({
      key: FieldsEnum.BankZipCode,
      visible: isCessionRequired,
      formName: FormsEnum.CheckoutForm,
    });
    setQuestionVisibility({
      key: FieldsEnum.BankId,
      visible: isCessionRequired,
      formName: FormsEnum.CheckoutForm,
    });
  },
};

export default cession;
